import type { ClosingPackageTaskType } from './closingPackageTaskTypes';
import {
  CLOSING_PACKAGE_TASK_TYPE,
  isClosingPackageTaskType,
  resolveClosingPackageCanonicalTaskType,
} from './closingPackageTaskTypes';

export type ClosingPackageAssigneeRole = 'accountant' | 'logist';

/** Assignee roles — mirrors backend `CLOSING_PACKAGE_TASK_ASSIGNEE` and `requireRole` on CP routes. */
export const CLOSING_PACKAGE_TASK_ASSIGNEE_ROLES: Readonly<
  Record<ClosingPackageTaskType, ReadonlyArray<ClosingPackageAssigneeRole>>
> = {
  [CLOSING_PACKAGE_TASK_TYPE.FORM_CLOSING_PACKAGE]: ['accountant'],
  [CLOSING_PACKAGE_TASK_TYPE.SEND_SCANS_TO_CLIENT]: ['logist'],
  [CLOSING_PACKAGE_TASK_TYPE.WAIT_CLIENT_APPROVAL]: ['logist'],
  [CLOSING_PACKAGE_TASK_TYPE.REVISE_CLOSING_PACKAGE]: ['accountant'],
  [CLOSING_PACKAGE_TASK_TYPE.PREPARE_ORIGINALS]: ['accountant'],
  [CLOSING_PACKAGE_TASK_TYPE.SEND_ORIGINALS]: ['accountant'],
  [CLOSING_PACKAGE_TASK_TYPE.CONFIRM_CLIENT_RECEIPT]: ['logist'],
  [CLOSING_PACKAGE_TASK_TYPE.SEND_VIA_EDO]: ['accountant'],
  [CLOSING_PACKAGE_TASK_TYPE.CONFIRM_EDO_RECEIPT]: ['accountant'],
};

function normalizeUserRole(role: string | null | undefined): string {
  return String(role || '').trim().toLowerCase();
}

function roleMatchesAssignee(userRole: string, allowed: ReadonlyArray<ClosingPackageAssigneeRole>): boolean {
  const normalized = normalizeUserRole(userRole);
  if (normalized === 'admin') return true;
  return allowed.some((role) => normalized === role || normalized.includes(role));
}

export function getClosingPackageTaskAssigneeRoles(
  taskType: string | null | undefined
): ReadonlyArray<ClosingPackageAssigneeRole> | null {
  const canonical = resolveClosingPackageCanonicalTaskType(taskType);
  if (!canonical) return null;
  return CLOSING_PACKAGE_TASK_ASSIGNEE_ROLES[canonical];
}

export function canRoleExecuteClosingPackageTask(
  userRole: string | null | undefined,
  taskType: string | null | undefined
): boolean {
  const allowed = getClosingPackageTaskAssigneeRoles(taskType);
  if (!allowed) return false;
  return roleMatchesAssignee(normalizeUserRole(userRole), allowed);
}

export function isClosingPackageApplicationTask(taskType: string | null | undefined): boolean {
  return isClosingPackageTaskType(taskType);
}
